import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import styled from '@emotion/styled'
import { RadioButtonGroup } from 'components/patterns'

import { QUERY_INPUT_TYPES } from 'utils/constants'

import { inputTypes } from './utils'

const {
  DIGITAL_INPUT,
  ANALOG_INPUT,
  CARRY,
  NATIVE_INPUT,
  CAN_INPUT,
  SWITCH_INPUT,
} = QUERY_INPUT_TYPES

const InputTypeEditor = ({
  currentValue,
  onTypeChange,
  disabled,
  isNativeOutput,
}) => (
  <StyledButtonGroup
    label={isNativeOutput ? strings.input_type : strings.type_title}
    currentValue={currentValue}
    buttons={inputTypes(disabled)}
    onChange={onTypeChange}
    vertical
    radioGroupClassName="input-type-radio-group"
  />
)

// default padding is 15, causes radio btn in sidebar to break
// onto next line. adjust padding seems best UI fix till sidebar wider.
const StyledButtonGroup = styled(RadioButtonGroup)`
  .ant-radio-button-wrapper.ant-radio-button-wrapper {
    padding: 0 12px;
  }
`

InputTypeEditor.defaultProps = {
  disabled: {},
}

InputTypeEditor.propTypes = {
  currentValue: PropTypes.string,
  disabled: PropTypes.shape({
    [DIGITAL_INPUT]: PropTypes.bool,
    [NATIVE_INPUT]: PropTypes.bool,
    [ANALOG_INPUT]: PropTypes.bool,
    [CAN_INPUT]: PropTypes.bool,
    [CARRY]: PropTypes.bool,
    [SWITCH_INPUT]: PropTypes.bool,
  }),
  onTypeChange: PropTypes.func,
  isNativeOutput: PropTypes.bool,
}

export default InputTypeEditor
